
const colors = {
    c1:"#ff4500",
    c2:"#ffa800",
    c3:"#ffd635",
    c4:"#00cc78",
    c5:"#7eed56",
    c6:"#2450a4",
    c7:"#3690ea",
    c8:"#51e9f4",
    c9:"#811e9f",
    c10:"#b44ac0",
    c11:"#ff99aa",
    c12:"#9c6926",
    c13:"#000000",
    c14:"#898d90",
    c15:"#d4d7d9",
    c16:"#ffffff",
}

export {
    colors
}